import styled from 'styled-components'

const BannerContainer = styled.div<{ color?: string }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${({ color }) => color};
  width: 100%;
  min-height: 20px;
  padding-left: var(--safe-area-inset-left);
  padding-right: var(--safe-area-inset-right);
`

const StyledVersionButton = styled.button<{ $textColor?: string }>`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;

  color: ${({ $textColor }) => $textColor};
`

export { BannerContainer, StyledVersionButton }
